import Vas from "../Vas";
import React from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import { MessageBox } from 'component-lib';

//var axios = require('axios');

class Request {
    
    static ajax(dataType,contentType,async,request,type,data,cache,processData,readyCallback,errorHandler,auth){
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        var isEdge = !isIE && !!window.StyleMedia;
        if (isEdge){

            /*let CancelToken = axios.CancelToken;
            let source = CancelToken.source();

            axios.interceptors.request.use(function (config){
                console.log("config");
                console.log(config);
            }, function (error){
                console.log("error");
                console.log(error);
            });
            axios({
                cancelToken: source.token,
                method: type,
                responseType:contentType,
                url: Vas.ApiUrl + request,
                headers:{
                    'accept-language': "de",
                    'x-sts-APIKey': Vas.ApiKey,
                    //xhr.setRequestHeader('Cache-Control','no-cache');
                    'Access-Control-Allow-Origin': '*',
                    'authorization' : localStorage.getItem('anonymous_token')
                },
                data: { data }
            })
            .then(function(response){
                console.log("response");
                console.log(response);
            })
            .catch(function(error){
                console.log("error2");
                console.log(error);
            })
            ;*/
            $.ajax({
                dataType: dataType,
                contentType: contentType,
                async: true,
                //url: '/api' + request,
                url:  encodeURI(Vas.ApiUrl +request),
                type: type,
                crossDomain: true,
                //cache: false,
                processData: processData,
                beforeSend: function (xhr) {
                    
                    xhr.setRequestHeader('accept-language', "de");
                    xhr.setRequestHeader('x-sts-APIKey', Vas.ApiKey);
                    //xhr.setRequestHeader('Cache-Control','no-cache');
                    xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
                    if (localStorage.getItem("vas_token"))
                        {xhr.setRequestHeader('authorization', localStorage.getItem('vas_token'));}
                    else if (localStorage.getItem("anonymous_token"))
                        {xhr.setRequestHeader('authorization', localStorage.getItem('anonymous_token'));}
                },
                data:data,
                success: function (data) {
                    console.log('blub');
                },
                error: function (data){
                    if (data){
                        if (data.responseJSON){
                            if (data.responseJSON.Description){
                                if (errorHandler && typeof(errorHandler) === 'function') {
                                    errorHandler(data);
                                } else {
                                    ReactDOM.render(<MessageBox
                                      AppURL={Vas.ApplicationUrl}
                                      Title={Vas.Resources.Titles["Error"]}
                                      Message={data.responseJSON.Description} />
                                        ,document.getElementById('messageContainer'));
                                }
                            }
                        }
                    }
                }
            });
            
            /*// Use Microsoft XDR
            //var xdr = new window.XDomainRequest();
           var xdr = new XMLHttpRequest(); 
            xdr.addEventListener("progress", updateProgress);
            xdr.addEventListener("load", transferComplete);
            xdr.addEventListener("error", transferFailed);
            xdr.addEventListener("abort", transferCanceled);

            xdr.open(type, '/api' + request );
            xdr.setRequestHeader('accept-language', localStorage.getItem('vas_language'));
            xdr.setRequestHeader('x-sts-APIKey', Vas.ApiKey);
            xdr.setRequestHeader('Cache-Control', "no-cache");
            xdr.setRequestHeader('Content-Type', contentType);
            xdr.setRequestHeader('Access-Control-Allow-Origin', '*');
            
            xdr.onreadystatechange = function (oEvent) {  
                //console.log("stateChange");
               // console.log(oEvent);
            };
            if (data){
               xdr.send(data); 
            } else {
                xdr.send(null);
            }
            
            
            function updateProgress (oEvent) {
                console.log("update");
                if (oEvent.lengthComputable) {
                //var percentComplete = oEvent.loaded / oEvent.total * 100;
                // ...
                } else {
                    console.log("update2");
                // Unable to compute progress information since the total size is unknown
                }
            }
            
            function transferComplete(evt) {
            console.log("The transfer is complete.");
            }
            
            function transferFailed(evt) {
                console.log("An error occurred while transferring the file.");
                console.log(evt);
            }
            
            function transferCanceled(evt) {
            console.log("The transfer has been canceled by the user.");
            }*/
        } else {
            $.ajax({
                dataType: dataType,
                contentType: contentType,
                async: async,
                url: encodeURI(Vas.ApiUrl+ request),
                type: type,
                cache: cache,
                processData: processData,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('accept-language', "de");
                    xhr.setRequestHeader('x-sts-APIKey', Vas.ApiKey);
                    if (localStorage.getItem("vas_token"))
                        {xhr.setRequestHeader('authorization',"bearer "+ localStorage.getItem('vas_token'));}
                    else if (localStorage.getItem("anonymous_token"))
                        {xhr.setRequestHeader('authorization', localStorage.getItem('anonymous_token'));}
                },
                data:data,
                success: function (data) {
                    if (data){
                        if (auth === false){
                            if (request !== "/accounts"){
                                if (data.Token !== localStorage.getItem('anonymous_token')){
                                    localStorage.setItem("anonymous_token", data.Token);
                                }
                            } else {
                                localStorage.setItem("vas_token", data.Token);
                            }
                        } else {
                            if (data.Token !== localStorage.getItem('vas_token')){
                                localStorage.setItem("vas_token", data.Token);
                            }
                        }
                        if (readyCallback && typeof(readyCallback) === 'function') {
                            readyCallback(data);
                        }
                    }
                },
                error: function (data){
                    if (data){
                        if (data.responseJSON){
                            if (data.responseJSON.Description){
                                if (errorHandler && typeof(errorHandler) === 'function') {
                                    errorHandler(data);
                                } else {
                                    ReactDOM.render(<MessageBox 
                                      AppURL={Vas.ApplicationUrl} 
                                      Title={Vas.Resources.Titles["Error"]} 
                                      Message={data.responseJSON.Description} />
                                        ,document.getElementById('messageContainer'));
                                }
                            }
                        } else if (data.responseText){
                            //if (data.responseJSON.Description){
                                if (errorHandler && typeof(errorHandler) === 'function') {
                                    errorHandler(data);
                                } else {
                                    ReactDOM.render(<MessageBox 
                                      AppURL={Vas.ApplicationUrl} 
                                      Title={Vas.Resources.Titles["Error"]} 
                                      Message={JSON.parse(data.responseText).Description} />
                                        ,document.getElementById('messageContainer'));
                                }
                            //}
                        }
                    }
                }
            });
        }
    }
}
export default Request;
